<template>
  <div>
    <el-row :style='{ width: "100%", height: height}' class="echarts">
      <IEcharts theme='shine' :option="lineOptions" :notMerge="true" :resizable="true" v-if="lineOptions !== null" />
    </el-row>
  </div>
</template>

<script>
  import 'echarts/theme/shine.js';
  import IEcharts from 'vue-echarts-v3/src/full.js';
  import { store } from '../scripts/store.js';
  import { events } from '../scripts/events.js'
  import { exponentiateNum, aptFontSize, aptPlotGrid } from '../scripts/utils.js';
  const _ = require('lodash');
  const fontSize = aptFontSize();
  const grid = aptPlotGrid();

  export default {
    name: 'ModalUnitLineLenFrequency',
    props: {
      index: Number,
      height: String,
      series: Object,
    },
    components: { IEcharts },
    asyncComputed: {
      lineOptions: function () {
        console.log(this.series)
        let title = this.series.title;
        if (title === '') { title = {show: false} }
        else { title =  { 
          text: this.series.title, 
          textStyle: { 
            fontSize: fontSize, 
            fontWeight: 'bold', 
            width: '20%',
            fontFamily: 'Oxygen', 
            }, 
          left: '40', 
        }}
        const series = this.series.data;
        const datatype = this.series.datatype;
        const lengthType = this.series.lengthType;
        const yLabel = ( datatype === "frequency" ) ? "Frequency" : "Density (per MB)";
        const xLabel = ( lengthType === "bases" ) ? "Repeat length(bp)" : "Repeat units";
        const range = this.series.x;
        const options = {
          title: title,
          tooltip: {},
          grid: {
            left: 55,
            top: grid.gridTop,
            bottom: 50,
            right: 5,
            // containLabel: true
          },
          toolbox: {
            top: grid.toolboxTop,
            right: 20,
            feature: {
              saveAsImage: { 
                title: 'Save as PNG', 
                show: true, 
                type: 'png', 
                name: `${this.series.title}_LenvsFrequency` 
              },
              dataView: { 
                title: 'View data', 
                readOnly: true, 
                lang: ['Data View', 'Go back'] 
              },
              magicType: { 
                show: true, 
                type: ['line', 'bar', 'stack', 'tiled'],
                title: {
                  line: 'Plot as line',
                  bar: 'Plot as bar',
                  stack: 'Stack data',
                  tiled: 'Unstack data'
                }
              },
            }
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(240, 240, 240, 0.8)',
            textStyle: {
              align: 'left',
              color: 'rgba(50, 50, 50, 0.8)'
            }
          },
          xAxis: {
            name: xLabel,
            nameLocation: 'middle',
            nameGap: 30,
            margin: 8,
            axisTick: { alignWithLabel: true, },
            nameTextStyle: {
              fontSize: 14,
              fontWeight: 'bold'
            },
            data: range
          },
          yAxis: {
            name: yLabel,
            nameLocation: 'middle',
            nameGap: 40,
            margin: 8,
            nameTextStyle: {
              fontSize: 14,
              fontWeight: 'bold'
            },
            type: 'value',
            axisLabel: {
              formatter: exponentiateNum
            }
          },
          legend: {
            show: true,
            type: 'scroll',
            top: grid.legendTop,
            right: 5,
          },
          series: series,
          animate: true,
        }
        return new Promise(resolve => setTimeout(() => resolve(options), (this.index/2) * store.settings.plotUpdateDelayFactor))
      }
    }
  }
</script>